    <p-toast></p-toast>
    <app-page-shell>
      <app-page-hero eyebrow="HR Core" [title]="employeeId ? 'Edit Employee' : 'New Employee'" subtitle="Create a source-of-truth HR profile without forcing portal login creation.">
        <div actions>
          <button pButton type="button" label="Cancel" severity="secondary" [outlined]="true" routerLink="/hr/employees"></button>
          <button pButton type="button" label="Save" icon="pi pi-save" [disabled]="form.invalid || saving" (click)="save()"></button>
        </div>
      </app-page-hero>

      @if (loading) {
        <p-progressBar mode="indeterminate"></p-progressBar>
      }

      <form [formGroup]="form" class="form-grid">
        <app-page-form-section icon="fa-solid fa-id-card" title="Profile" subtitle="Basic employee identity and logistics worker category.">
          <div class="field-grid">
            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-user"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <input id="displayName" pInputText formControlName="displayName" />
                <label for="displayName">Display name</label>
              </p-iftaLabel>
            </p-inputGroup>
            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-hashtag"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <input id="employeeNumber" pInputText formControlName="employeeNumber" />
                <label for="employeeNumber">Employee number</label>
              </p-iftaLabel>
            </p-inputGroup>
            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-signature"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <input id="firstName" pInputText formControlName="firstName" />
                <label for="firstName">First name</label>
              </p-iftaLabel>
            </p-inputGroup>
            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-signature"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <input id="lastName" pInputText formControlName="lastName" />
                <label for="lastName">Last name</label>
              </p-iftaLabel>
            </p-inputGroup>
            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-envelope"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <input id="emailAddress" pInputText formControlName="emailAddress" />
                <label for="emailAddress">Email</label>
              </p-iftaLabel>
            </p-inputGroup>
            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-phone"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <input id="phoneNumber" pInputText formControlName="phoneNumber" />
                <label for="phoneNumber">Phone</label>
              </p-iftaLabel>
            </p-inputGroup>
            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-link"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <p-select
                  inputId="customerId"
                  [options]="customerOptions"
                  optionLabel="label"
                  optionValue="value"
                  formControlName="customerId"
                  [filter]="true"
                  filterBy="label,emailAddress,phoneNumber"
                  [showClear]="true"
                  [loading]="loading"
                  appendTo="body"
                  styleClass="w-full"></p-select>
                <label for="customerId">Linked portal employee</label>
              </p-iftaLabel>
            </p-inputGroup>
            <div class="wide linked-actions">
              <button pButton type="button" label="Create linked party" icon="fa-solid fa-user-plus" severity="secondary" [outlined]="true" (click)="openLinkedEmployeeCreator()"></button>
              <button pButton type="button" label="View profile" icon="fa-solid fa-up-right-from-square" severity="secondary" [outlined]="true" (click)="viewLinkedCustomerProfile()" [disabled]="!form.get('customerId')?.value"></button>
            </div>
            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-briefcase"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <p-select inputId="workerCategory" [options]="categoryOptions" formControlName="workerCategory" styleClass="w-full"></p-select>
                <label for="workerCategory">Worker category</label>
              </p-iftaLabel>
            </p-inputGroup>
            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-user-tag"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <p-select inputId="employeeType" [options]="typeOptions" formControlName="employeeType" styleClass="w-full"></p-select>
                <label for="employeeType">Employee type</label>
              </p-iftaLabel>
            </p-inputGroup>
            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-circle-check"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <p-select inputId="employeeStatus" [options]="statusOptions" formControlName="status" styleClass="w-full"></p-select>
                <label for="employeeStatus">Status</label>
              </p-iftaLabel>
            </p-inputGroup>
          </div>
        </app-page-form-section>

        <app-page-form-section icon="fa-solid fa-sitemap" title="Organization" subtitle="Department, job, position, manager, and operating location.">
          <div class="field-grid">
            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-building-user"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <p-select inputId="departmentId" [options]="departmentOptions" formControlName="departmentId" [showClear]="true" styleClass="w-full"></p-select>
                <label for="departmentId">Department</label>
              </p-iftaLabel>
            </p-inputGroup>
            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-briefcase"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <p-select inputId="jobId" [options]="jobOptions" formControlName="jobId" [showClear]="true" styleClass="w-full"></p-select>
                <label for="jobId">Job</label>
              </p-iftaLabel>
            </p-inputGroup>
            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-id-badge"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <p-select inputId="positionId" [options]="positionOptions" formControlName="positionId" [showClear]="true" styleClass="w-full"></p-select>
                <label for="positionId">Position</label>
              </p-iftaLabel>
            </p-inputGroup>
            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-user-tie"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <p-select inputId="managerEmployeeId" [options]="managerOptions" formControlName="managerEmployeeId" [showClear]="true" styleClass="w-full"></p-select>
                <label for="managerEmployeeId">Manager</label>
              </p-iftaLabel>
            </p-inputGroup>
            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-location-dot"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <p-select inputId="workLocationId" appLazyLocationPicker formControlName="workLocationId" optionLabel="name" optionValue="id" [showClear]="true" [filter]="true" filterBy="name" appendTo="body" styleClass="w-full"></p-select>
                <label for="workLocationId">Work location</label>
              </p-iftaLabel>
            </p-inputGroup>
            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-calendar-plus"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <input id="startDate" pInputText type="date" formControlName="startDate" />
                <label for="startDate">Start date</label>
              </p-iftaLabel>
            </p-inputGroup>
            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-calendar-xmark"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <input id="endDate" pInputText type="date" formControlName="endDate" />
                <label for="endDate">End date</label>
              </p-iftaLabel>
            </p-inputGroup>
            <div class="wide rich-field">
              <label for="notes">Notes</label>
              <p-editor id="notes" formControlName="notes" [style]="{ height: '220px' }"></p-editor>
            </div>
          </div>
        </app-page-form-section>

        <app-page-form-section icon="fa-solid fa-fingerprint" title="Biometric" subtitle="Biometric provider mapping and device employee key used by sync ingestion.">
          <div class="field-grid">
            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-fingerprint"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <p-select inputId="biometricProviderCode" [options]="biometricProviderOptions" optionLabel="label" optionValue="value" formControlName="biometricProviderCode" [showClear]="true" [filter]="true" filterBy="label,value" appendTo="body" styleClass="w-full"></p-select>
                <label for="biometricProviderCode">Biometric provider</label>
              </p-iftaLabel>
            </p-inputGroup>
            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-key"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <input id="biometricEmployeeIdentifierKey" pInputText formControlName="biometricEmployeeIdentifierKey" />
                <label for="biometricEmployeeIdentifierKey">Biometric employee identifier key</label>
              </p-iftaLabel>
            </p-inputGroup>
          </div>
        </app-page-form-section>
      </form>

      <app-party-quick-create-dialog
        [visible]="linkedEmployeeDialogVisible"
        (visibleChange)="linkedEmployeeDialogVisible = $event"
        mode="employee"
        [countries]="countries"
        [owningCompany]="owningCompany"
        [linkedCompany]="owningCompany"
        [companyRequired]="true"
        titleOverride="Create linked portal employee"
        submitLabel="Create"
        (created)="onLinkedEmployeeCreated($event)"
        (failed)="onLinkedEmployeeCreationFailed($event)">
      </app-party-quick-create-dialog>

      <p-dialog
        header="Linked portal employee"
        [(visible)]="linkedCustomerDialogVisible"
        [modal]="true"
        [draggable]="false"
        [resizable]="false"
        [style]="{ width: 'min(680px, 94vw)' }"
        appendTo="body">
        @if (linkedCustomerProfile) {
          <div class="customer-profile-dialog">
            <div class="customer-profile-header">
              <div class="customer-avatar customer-avatar-md">
                <img [src]="linkedCustomerProfile.imageUrl || 'https://cdn-icons-png.flaticon.com/512/149/149071.png'" [alt]="linkedCustomerProfile.name || 'Customer profile'" />
              </div>
              <div>
                <h3>{{ linkedCustomerProfile.name || 'Customer' }}</h3>
                <p>{{ linkedCustomerProfile.company?.name || 'Tenant employee party' }}</p>
              </div>
            </div>
            <div class="detail-list dialog-detail-list">
              <div><dt>ID</dt><dd>{{ linkedCustomerProfile.id || '-' }}</dd></div>
              <div><dt>Email</dt><dd>{{ linkedCustomerProfile.emailAddress || '-' }}</dd></div>
              <div><dt>Phone</dt><dd>{{ linkedCustomerProfile.phoneNumber || '-' }}</dd></div>
              <div><dt>Address</dt><dd>{{ linkedCustomerProfile.address || '-' }}</dd></div>
              <div><dt>Company</dt><dd>{{ linkedCustomerProfile.company?.name || '-' }}</dd></div>
            </div>
          </div>
        } @else {
          <p>Unable to load linked portal employee profile.</p>
        }
        <ng-template pTemplate="footer">
          <div class="dialog-footer">
            <button pButton type="button" label="Open full profile" icon="fa-solid fa-arrow-up-right-from-square" severity="secondary" [outlined]="true" [routerLink]="['/customer', linkedCustomerProfile?.id]" (click)="linkedCustomerDialogVisible = false" [disabled]="!linkedCustomerProfile?.id"></button>
            <button pButton type="button" label="Close" icon="pi pi-times" severity="secondary" [outlined]="true" (click)="linkedCustomerDialogVisible = false"></button>
          </div>
        </ng-template>
      </p-dialog>
    </app-page-shell>
